/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import { BootstrapDialog, CustomGrid, CustomInfosForm } from '../../../../assets/style/globalStyle';
import { NotificationManager } from 'react-notifications';
import {
  IconButton,
  DialogTitle,
  DialogContent,
  DialogActions,
  Drawer,
  Button,
  Grid,
  TextField,
  MenuItem,
  Box,
  Stack,
  Typography,
  Divider,
  Autocomplete
} from '@mui/material';
import DataGrid, { Column, Paging } from 'devextreme-react/data-grid';

import Iconify from '../../../../@core/theme/Iconify';
import Scrollbar from '../../../components/multiplesComponents/Scrollbar';
import CloseIcon from '@mui/icons-material/Close';
import ManageHistoryIcon from '@mui/icons-material/ManageHistory';
import PropTypes from 'prop-types';
import configAxios from '../../../../services/configAxios';
import { useSelector } from 'react-redux';
import { selectLogin } from '../../../../store/login/loginSlice';
import { formatDate } from '../../../../@core/utils/utilsFunctions';
import HistoryLead from './HistoryLead';

const INTERACTION_CANALS = ['Ligação', 'WhatsApp', 'E-mail', 'Presencial', 'Outro'];
const INTERACTION_RESULTS = ['Atendeu', 'Não atendeu', 'Retornar', 'Sem interesse', 'Outro'];
const RESULT_COLORS = {
  Atendeu: 'success',
  'Não atendeu': 'error',
  Retornar: 'warning',
  'Sem interesse': 'error',
  Outro: 'warning'
};
const CANAL_ICONS = {
  Ligação: 'eva:phone-outline',
  WhatsApp: 'eva:message-circle-outline',
  'E-mail': 'eva:email-outline',
  Presencial: 'eva:people-outline',
  Outro: 'eva:more-horizontal-fill'
};
const TEMPERATURAS = [
  { value: 'Frio', color: 'info' },
  { value: 'Morno', color: 'warning' },
  { value: 'Quente', color: 'error' }
];
const FAIXA_LABELS = [
  ['faixa_0_18', '0 a 18 anos'],
  ['faixa_19_23', '19 a 23 anos'],
  ['faixa_24_28', '24 a 28 anos'],
  ['faixa_29_33', '29 a 33 anos'],
  ['faixa_34_38', '34 a 38 anos'],
  ['faixa_39_43', '39 a 43 anos'],
  ['faixa_44_48', '44 a 48 anos'],
  ['faixa_49_53', '49 a 53 anos'],
  ['faixa_54_58', '54 a 58 anos'],
  ['faixa_59_99', '59 anos ou mais']
];

const addEditLead = (props) => {
  const infoStateTemp = useSelector(selectLogin);
  const [infoState] = useState({ ...infoStateTemp.userLoggedIn[0] });
  const isBroker = infoState.id_type_user === 2;
  const [infosLead, setInfosLead] = useState({});
  const [statuses, setStatuses] = useState([]);
  const [losses, setLosses] = useState([]);
  const [allTags, setAllTags] = useState([]);
  const [allActions, setAllActions] = useState([]);
  const [infosBroker, setInfosBroker] = useState([]);
  const [infosVend, setInfosVend] = useState([]);
  const [openInteracao, setOpenInteracao] = useState(false);
  const [interaction, setInteraction] = useState({
    canal: 'Ligação',
    resultado: 'Atendeu',
    obs: ''
  });
  const [actionLead, setActionLead] = useState({
    id_action: '',
    data_hora_marcada: ''
  });
  const [actionError, setActionError] = useState(false);
  const [selectedTagId, setSelectedTagId] = useState('');
  const [openTag, setOpenTag] = useState(false);
  const [openHistory, setOpenHistory] = useState(false);
  const [infosHistoryLead, setInfosHistoryLead] = useState([]);

  useEffect(() => {
    getStatusLeads();
    getLosses();
    getTags();
    getActions();
    if (!isBroker) {
      getBrokers();
    }
    const lead = props.infosItemEdit ? { ...props.infosItemEdit } : {};
    if (isBroker && !lead.id_broker) {
      lead.id_broker = infoState.id_broker;
    }
    setInfosLead(lead);
    loadVendors(lead.id_broker);
  }, [props.infosItemEdit]);

  function getStatusLeads() {
    configAxios
      .get('/leads/getStatusLeads')
      .then((response) => {
        setStatuses(response.data);
      })
      .catch(() => {
        NotificationManager.warning(
          'Tivemos dificuldades para buscar os status, tente novamente!',
          'Atenção'
        );
      });
  }

  function getLosses() {
    configAxios
      .get('/leads/getLosses')
      .then((response) => {
        setLosses(response.data);
      })
      .catch(() => {
        NotificationManager.warning(
          'Tivemos dificuldades para buscar os motivos, tente novamente!',
          'Atenção'
        );
      });
  }

  function getTags() {
    configAxios
      .get('/leads/getTags')
      .then((response) => {
        setAllTags(response.data);
      })
      .catch(() => {
        NotificationManager.warning(
          'Tivemos dificuldades para buscar as tags, tente novamente!',
          'Atenção'
        );
      });
  }

  function getActions() {
    configAxios
      .get('/leads/getActions')
      .then((response) => {
        setAllActions(response.data);
      })
      .catch(() => {
        NotificationManager.warning(
          'Tivemos dificuldades para buscar as ações, tente novamente!',
          'Atenção'
        );
      });
  }

  function getBrokers() {
    configAxios
      .post('/brokers/listBrokerLabelUsers')
      .then((response) =>
        setInfosBroker((response.data || []).filter((item) => item.id !== '' && item.id != null))
      )
      .catch(() => {
        NotificationManager.warning(
          'Tivemos dificuldades para buscar as corretoras, tente novamente!',
          'Atenção'
        );
      });
  }

  function loadVendors(id_broker) {
    if (!id_broker) {
      setInfosVend([]);
      return;
    }
    configAxios
      .get(`/brokers/listVendLabel/${id_broker}`)
      .then((response) =>
        setInfosVend((response.data || []).filter((item) => item.id !== '' && item.id != null))
      )
      .catch(() => {
        NotificationManager.warning(
          'Tivemos dificuldades para buscar os vendedores, tente novamente!',
          'Atenção'
        );
      });
  }

  function getLead(id) {
    configAxios
      .get(`/leads/getLead/${id}`)
      .then((response) => {
        const data = response.data || {};
        const tags = typeof data.tags === 'string' ? JSON.parse(data.tags) : data.tags || [];
        if (isBroker && !data.id_broker) {
          data.id_broker = infoState.id_broker;
        }
        setInfosLead({
          ...data,
          tags: Array.isArray(tags) ? tags : []
        });
        loadVendors(data.id_broker);
      })
      .catch(() => {
        NotificationManager.warning(
          'Tivemos dificuldades para buscar o lead, tente novamente!',
          'Atenção'
        );
      });
  }

  function HandleInputChange(event) {
    const { name, value } = event.target;
    setInfosLead({ ...infosLead, [name]: value === '' ? null : value });
  }

  function HandleSubmit(event) {
    event.preventDefault();
    if (!infosLead.id_lead) {
      return;
    }
    if (actionLead.id_action && !actionLead.data_hora_marcada) {
      setActionError(true);
      NotificationManager.warning('Informe a data marcada!', 'Atenção');
      return;
    }
    const tagIds = (infosLead.tags || []).map((t) => Number(t.id_tag));
    configAxios
      .post('/leads/updateLead', {
        id_lead: infosLead.id_lead,
        id_status_lead: infosLead.id_status_lead || null,
        id_user: infosLead.id_user || null,
        id_broker: infosLead.id_broker || null,
        id_user_alt: infoState.id,
        temperatura: infosLead.temperatura,
        id_loss: infosLead.id_loss || null
      })
      .then(() => {
        return configAxios.post('/leads/updateLeadTags', {
          id_lead: infosLead.id_lead,
          tagIds
        });
      })
      .then(() => {
        NotificationManager.success('Lead atualizado!', 'Sucesso');
        getLead(infosLead.id_lead);
        props.functionGrid();
      })
      .catch(() => {
        NotificationManager.error(
          'Tivemos dificuldades para atender a requisição no momento, tente novamente!',
          'Atenção'
        );
      });
  }

  function saveLeadTags(tagIds) {
    return configAxios.post('/leads/updateLeadTags', {
      id_lead: infosLead.id_lead,
      tagIds
    });
  }

  function addTagLead(event) {
    event.preventDefault();
    if (!selectedTagId) {
      NotificationManager.warning('Selecione a tag!', 'Atenção');
      return;
    }
    const tagIds = [...selectedTagIds, Number(selectedTagId)];
    saveLeadTags(tagIds)
      .then(() => {
        NotificationManager.success('Tag adicionada!', 'Sucesso');
        setSelectedTagId('');
        setOpenTag(false);
        getLead(infosLead.id_lead);
        if (props.functionGrid) {
          props.functionGrid();
        }
      })
      .catch(() => {
        NotificationManager.error(
          'Tivemos dificuldades para atender a requisição no momento, tente novamente!',
          'Atenção'
        );
      });
  }

  function removeTagLead(id_tag) {
    const tagIds = selectedTagIds.filter((id) => Number(id) !== Number(id_tag));
    saveLeadTags(tagIds)
      .then(() => {
        NotificationManager.success('Tag removida!', 'Sucesso');
        getLead(infosLead.id_lead);
        if (props.functionGrid) {
          props.functionGrid();
        }
      })
      .catch(() => {
        NotificationManager.error(
          'Tivemos dificuldades para atender a requisição no momento, tente novamente!',
          'Atenção'
        );
      });
  }

  function addActionLead(event) {
    event.preventDefault();
    if (!actionLead.id_action) {
      NotificationManager.warning('Selecione a ação!', 'Atenção');
      return;
    }
    if (!actionLead.data_hora_marcada) {
      setActionError(true);
      NotificationManager.warning('Informe a data marcada!', 'Atenção');
      return;
    }
    setActionError(false);
    configAxios
      .post('/leads/addActionLead', {
        id_lead: infosLead.id_lead,
        id_action: actionLead.id_action,
        data_hora_marcada: actionLead.data_hora_marcada
      })
      .then(() => {
        NotificationManager.success('Ação registrada!', 'Sucesso');
        setActionLead({ id_action: '', data_hora_marcada: '' });
        setActionError(false);
        getLead(infosLead.id_lead);
      })
      .catch(() => {
        NotificationManager.error(
          'Tivemos dificuldades para atender a requisição no momento, tente novamente!',
          'Atenção'
        );
      });
  }

  function addInteraction(event) {
    event.preventDefault();
    configAxios
      .post('/leads/addInteraction', {
        id_lead: infosLead.id_lead,
        ...interaction,
        id_user: infoState.id
      })
      .then(() => {
        NotificationManager.success('Interação registrada!', 'Sucesso');
        setInteraction({ canal: 'Ligação', resultado: 'Atendeu', obs: '' });
        setOpenInteracao(false);
        getLead(infosLead.id_lead);
      })
      .catch(() => {
        NotificationManager.error(
          'Tivemos dificuldades para atender a requisição no momento, tente novamente!',
          'Atenção'
        );
      });
  }

  function HandleClose() {
    props.setOpenModal(false);
    props.functionGrid();
    setInfosLead({});
    setOpenInteracao(false);
    setOpenTag(false);
    setOpenHistory(false);
    setSelectedTagId('');
    setActionError(false);
  }

  function getLeadHistory() {
    if (!infosLead.id_lead) {
      return;
    }
    configAxios
      .get(`/leads/getLeadHistory/${infosLead.id_lead}`)
      .then((result) => {
        setInfosHistoryLead(result.data);
        setOpenHistory(true);
      })
      .catch(() => {
        NotificationManager.warning(
          'Tivemos dificuldades para buscar o histórico, tente novamente!',
          'Atenção'
        );
      });
  }

  const selectedStatus = statuses.find((s) => s.id_status_lead === infosLead.id_status_lead);
  const selectedTagIds = (infosLead.tags || []).map((t) => Number(t.id_tag));
  const faixaRows = FAIXA_LABELS.map(([key, faixa]) => ({
    faixa,
    quantidade: Number(infosLead[key]) || 0
  })).filter((row) => row.quantidade > 0);
  const tagsCatalogo = allTags.filter((t) => !selectedTagIds.includes(Number(t.id_tag)));

  const BootstrapDialogTitle = (titleProps) => {
    const { children, onClose, ...other } = titleProps;
    return (
      <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
        {children}
        {onClose ? (
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: 'absolute',
              right: 10,
              top: 8,
              color: (theme) => theme.palette.grey[500]
            }}>
            <CloseIcon />
          </IconButton>
        ) : null}
      </DialogTitle>
    );
  };

  BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired
  };

  return (
    <>
      <Drawer
        anchor="right"
        open={props.openModal}
        onClose={HandleClose}
        PaperProps={{
          sx: {
            width: { xs: '100%', sm: 520, md: 640 },
            maxWidth: '100%'
          }
        }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            sx={{ px: 2, py: 1.5, borderBottom: 1, borderColor: 'divider' }}>
            <Typography
              id="lead-drawer-title"
              variant="h6"
              noWrap
              sx={{ pr: 1, textTransform: 'uppercase' }}>
              {infosLead.nome || 'Lead'}
            </Typography>
            <IconButton aria-label="close" onClick={HandleClose}>
              <CloseIcon />
            </IconButton>
          </Stack>
          <form
            onSubmit={HandleSubmit}
            style={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0 }}>
            <Box sx={{ flex: 1, minHeight: 0 }}>
              <Scrollbar sx={{ height: 1 }}>
                <CustomGrid>
                  <CustomInfosForm>
                    Lead #{infosLead.id_lead || '-'} · {infosLead.tp_contrat || '-'}
                  </CustomInfosForm>
                  <CustomInfosForm>Campos obrigatórios possuem asterisco (*)</CustomInfosForm>
                  {infosLead.id_lead && (
                    <>
                      <Grid container spacing={2} sx={{ mt: 1 }}>
                        <Grid item xs={12}>
                          <TextField
                            select
                            variant="outlined"
                            name="id_status_lead"
                            fullWidth
                            size="small"
                            label="Status"
                            value={infosLead.id_status_lead || ''}
                            onChange={(event) => HandleInputChange(event)}>
                            <MenuItem value="">Selecione</MenuItem>
                            {statuses.map((s) => (
                              <MenuItem key={s.id_status_lead} value={s.id_status_lead}>
                                {s.status}
                              </MenuItem>
                            ))}
                          </TextField>
                        </Grid>
                        <Grid item xs={12}>
                          <CustomInfosForm sx={{ mb: 1 }}>Temperatura</CustomInfosForm>
                          <Stack direction="row" sx={{ mt: 1, gap: 1 }}>
                            {TEMPERATURAS.map((item) => (
                              <Button
                                key={item.value}
                                type="button"
                                size="small"
                                color={item.color}
                                variant={
                                  infosLead.temperatura === item.value ? 'contained' : 'outlined'
                                }
                                onClick={() =>
                                  setInfosLead({ ...infosLead, temperatura: item.value })
                                }
                                sx={{ flex: 1 }}>
                                {item.value}
                              </Button>
                            ))}
                          </Stack>
                        </Grid>
                        {!isBroker && (
                          <Grid item xs={12} sm={6}>
                            <Autocomplete
                              options={infosBroker}
                              value={
                                infosBroker.find(
                                  (item) => String(item.id) === String(infosLead.id_broker)
                                ) || null
                              }
                              getOptionLabel={(option) => option.label || ''}
                              isOptionEqualToValue={(option, value) =>
                                String(option.id) === String(value.id)
                              }
                              onChange={(event, value) => {
                                setInfosLead({
                                  ...infosLead,
                                  id_broker: value ? value.id : null,
                                  id_user: null
                                });
                                loadVendors(value ? value.id : null);
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label="Corretora"
                                  size="small"
                                  variant="outlined"
                                />
                              )}
                            />
                          </Grid>
                        )}
                        <Grid item xs={12} sm={isBroker ? 12 : 6}>
                          <Autocomplete
                            options={infosVend}
                            value={
                              infosVend.find(
                                (item) => String(item.id) === String(infosLead.id_user)
                              ) || null
                            }
                            getOptionLabel={(option) => option.label || ''}
                            isOptionEqualToValue={(option, value) =>
                              String(option.id) === String(value.id)
                            }
                            onChange={(event, value) =>
                              setInfosLead({ ...infosLead, id_user: value ? value.id : null })
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Vendedor"
                                size="small"
                                variant="outlined"
                                fullWidth
                              />
                            )}
                          />
                        </Grid>
                        {selectedStatus?.perdido === 'S' && (
                          <Grid item xs={12}>
                            <TextField
                              select
                              variant="outlined"
                              name="id_loss"
                              fullWidth
                              size="small"
                              sx={{ textTransform: 'none' }}
                              label="Motivos da perda"
                              value={infosLead.id_loss || ''}
                              onChange={(event) => HandleInputChange(event)}>
                              <MenuItem value="">Selecione</MenuItem>
                              {losses.map((l) => (
                                <MenuItem key={l.id_loss} value={l.id_loss}>
                                  {l.motivo}
                                </MenuItem>
                              ))}
                            </TextField>
                          </Grid>
                        )}
                      </Grid>

                      <CustomInfosForm sx={{ mt: 2, mb: 1 }}>Dados do contato</CustomInfosForm>
                      <Grid container spacing={2} sx={{ mt: 1 }}>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            variant="outlined"
                            fullWidth
                            size="small"
                            label="Celular"
                            value={infosLead.celular || '-'}
                            InputLabelProps={{ shrink: true }}
                            disabled
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            variant="outlined"
                            fullWidth
                            size="small"
                            label="E-mail"
                            value={infosLead.email || '-'}
                            InputLabelProps={{ shrink: true }}
                            disabled
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            variant="outlined"
                            fullWidth
                            size="small"
                            label="CPF/CNPJ"
                            value={infosLead.cpf_cnpj || '-'}
                            InputLabelProps={{ shrink: true }}
                            disabled
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            variant="outlined"
                            fullWidth
                            size="small"
                            label="Razão social"
                            value={infosLead.razao_social || '-'}
                            InputLabelProps={{ shrink: true }}
                            disabled
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            variant="outlined"
                            fullWidth
                            size="small"
                            label="Horário contato"
                            value={infosLead.horario_contato || '-'}
                            InputLabelProps={{ shrink: true }}
                            disabled
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            variant="outlined"
                            fullWidth
                            size="small"
                            label="Cidade/UF"
                            value={`${infosLead.cidade || '-'} / ${infosLead.uf || '-'}`}
                            InputLabelProps={{ shrink: true }}
                            disabled
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            variant="outlined"
                            fullWidth
                            size="small"
                            label="Possui plano"
                            value={infosLead.possui_plano === 'S' ? 'Sim' : 'Não'}
                            InputLabelProps={{ shrink: true }}
                            disabled
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            variant="outlined"
                            fullWidth
                            size="small"
                            label="Operadora atual"
                            value={infosLead.operadora_atual || '-'}
                            InputLabelProps={{ shrink: true }}
                            disabled
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            variant="outlined"
                            fullWidth
                            size="small"
                            label="Há quanto tempo possui o plano"
                            value={infosLead.tempo_operadora_atual || '-'}
                            InputLabelProps={{ shrink: true }}
                            disabled
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            variant="outlined"
                            fullWidth
                            size="small"
                            label="Acomodação"
                            value={infosLead.acomodacao || '-'}
                            InputLabelProps={{ shrink: true }}
                            disabled
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            variant="outlined"
                            fullWidth
                            size="small"
                            label="Coparticipação"
                            value={infosLead.copart || '-'}
                            InputLabelProps={{ shrink: true }}
                            disabled
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <TextField
                            variant="outlined"
                            fullWidth
                            size="small"
                            label="Previsão início"
                            value={infosLead.previsao_inicio || '-'}
                            InputLabelProps={{ shrink: true }}
                            disabled
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            variant="outlined"
                            fullWidth
                            size="small"
                            label="Invest. pessoa"
                            value={infosLead.investimento_pessoa || '-'}
                            InputLabelProps={{ shrink: true }}
                            disabled
                          />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            variant="outlined"
                            fullWidth
                            size="small"
                            label="Invest. total"
                            value={infosLead.investimento_total || '-'}
                            InputLabelProps={{ shrink: true }}
                            disabled
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <TextField
                            variant="outlined"
                            fullWidth
                            size="small"
                            label="Observação"
                            value={infosLead.obs || '-'}
                            InputLabelProps={{ shrink: true }}
                            multiline
                            minRows={2}
                            disabled
                          />
                        </Grid>
                      </Grid>

                      <CustomInfosForm sx={{ mt: 2, mb: 1 }}>
                        Beneficiários por faixa etária
                      </CustomInfosForm>
                      <Typography variant="body2" sx={{ mb: 1 }} fontWeight={700}>
                        Total de beneficiários: {infosLead.benefs_total || 0}
                      </Typography>
                      <DataGrid
                        dataSource={faixaRows}
                        showBorders={true}
                        wordWrapEnabled={true}
                        allowColumnResizing={true}
                        width="100%"
                        noDataText={'Não há beneficiários'}>
                        <Paging enabled={false} />
                        <Column dataField="faixa" caption="Faixa etária" />
                        <Column dataField="quantidade" caption="Quantidade" alignment="right" />
                      </DataGrid>

                      <Stack
                        direction="row"
                        alignItems="center"
                        justifyContent="space-between"
                        sx={{ mt: 2, mb: 1.5 }}>
                        <CustomInfosForm sx={{ mb: 0 }}>Tags</CustomInfosForm>
                        <Button
                          type="button"
                          variant="contained"
                          size="medium"
                          color="primary"
                          onClick={() => setOpenTag(true)}
                          startIcon={<Iconify icon="eva:plus-fill" />}>
                          Adicionar tag
                        </Button>
                      </Stack>
                      <DataGrid
                        dataSource={infosLead.tags || []}
                        showBorders={true}
                        wordWrapEnabled={true}
                        allowColumnResizing={true}
                        width="100%"
                        noDataText={'Não há tags cadastradas'}>
                        <Paging enabled={false} />
                        <Column dataField="tag" caption="Tag" />
                        <Column
                          dataField="Ações"
                          width={80}
                          alignment="center"
                          allowSorting={false}
                          cellRender={(data) => (
                            <IconButton
                              type="button"
                              size="small"
                              color="error"
                              onClick={() => removeTagLead(data.data.id_tag)}>
                              <Iconify icon="eva:trash-2-outline" />
                            </IconButton>
                          )}
                        />
                      </DataGrid>

                      <CustomInfosForm sx={{ mt: 2, mb: 1 }}>Ações</CustomInfosForm>
                      <Grid container spacing={2} sx={{ mt: 1 }}>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            select
                            variant="outlined"
                            fullWidth
                            size="small"
                            label="Ação"
                            name="id_action"
                            value={actionLead.id_action}
                            onChange={(event) => {
                              setActionError(false);
                              setActionLead({ ...actionLead, id_action: event.target.value });
                            }}>
                            <MenuItem value="">Selecione</MenuItem>
                            {allActions.map((a) => (
                              <MenuItem key={a.id_action} value={a.id_action}>
                                {a.acao}
                              </MenuItem>
                            ))}
                          </TextField>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                          <TextField
                            variant="outlined"
                            fullWidth
                            size="small"
                            type="date"
                            name="data_hora_marcada"
                            label={actionLead.id_action ? 'Data marcada *' : 'Data marcada'}
                            InputLabelProps={{ shrink: true }}
                            value={actionLead.data_hora_marcada}
                            error={
                              actionError &&
                              Boolean(actionLead.id_action) &&
                              !actionLead.data_hora_marcada
                            }
                            helperText={
                              actionError &&
                              Boolean(actionLead.id_action) &&
                              !actionLead.data_hora_marcada
                                ? 'Campo obrigatório'
                                : ''
                            }
                            onChange={(event) => {
                              setActionError(false);
                              setActionLead({
                                ...actionLead,
                                data_hora_marcada: event.target.value
                              });
                            }}
                          />
                        </Grid>
                        <Grid item xs={12}>
                          <Stack direction="row" justifyContent="end">
                            <Button
                              type="button"
                              variant="contained"
                              size="medium"
                              color="primary"
                              onClick={addActionLead}
                              startIcon={<Iconify icon="eva:plus-fill" />}>
                              Registrar ação
                            </Button>
                          </Stack>
                        </Grid>
                      </Grid>
                      <Stack spacing={1.5} sx={{ mt: 1.5, mb: 2 }}>
                        {(infosLead.actions || []).map((item) => {
                          const row = item.dataValues || item;
                          const acao = allActions.find(
                            (a) => Number(a.id_action) === Number(row.id_action)
                          );
                          return (
                            <Box
                              key={row.id}
                              sx={{
                                p: 1.5,
                                border: 1,
                                borderColor: 'grey.200'
                              }}>
                              <Stack
                                direction="row"
                                alignItems="center"
                                justifyContent="space-between">
                                <Typography variant="subtitle2">{acao?.acao || 'Ação'}</Typography>
                                <Stack
                                  direction="row"
                                  alignItems="center"
                                  spacing={1}
                                  divider={<Divider orientation="vertical" flexItem />}>
                                  <Typography variant="caption" color="text.secondary">
                                    Data marcada:{' '}
                                    {row.data_hora_marcada
                                      ? formatDate(String(row.data_hora_marcada).substring(0, 10))
                                      : '-'}
                                  </Typography>
                                  <Typography variant="caption" color="text.secondary">
                                    SLA:{' '}
                                    {acao && Number(acao.sla) > 0
                                      ? `${Number(acao.sla)} ${
                                          Number(acao.sla) === 1 ? 'dia' : 'dias'
                                        }`
                                      : '-'}
                                  </Typography>
                                </Stack>
                              </Stack>
                            </Box>
                          );
                        })}
                        {!(infosLead.actions || []).length && (
                          <Typography variant="body2" color="text.secondary">
                            Não há ações cadastradas
                          </Typography>
                        )}
                      </Stack>

                      <Stack
                        direction="row"
                        alignItems="center"
                        justifyContent="space-between"
                        sx={{ mt: 1, mb: 1.5 }}>
                        <CustomInfosForm sx={{ mb: 0 }}>Linha do tempo</CustomInfosForm>
                        <Button
                          type="button"
                          variant="contained"
                          size="medium"
                          color="primary"
                          onClick={() => setOpenInteracao(true)}
                          startIcon={<Iconify icon="eva:plus-fill" />}>
                          Registrar interação
                        </Button>
                      </Stack>
                      {!(infosLead.interactions || []).length ? (
                        <Typography variant="body2" color="text.secondary">
                          Não há interações cadastradas
                        </Typography>
                      ) : (
                        <Stack divider={<Divider />}>
                          {(infosLead.interactions || []).map((item) => (
                            <Stack
                              key={item.id}
                              direction="row"
                              spacing={1.5}
                              alignItems="flex-start"
                              sx={{ py: 1.25 }}>
                              <Box
                                sx={{
                                  width: 32,
                                  height: 32,
                                  borderRadius: '50%',
                                  bgcolor: 'grey.200',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  flexShrink: 0
                                }}>
                                <Iconify
                                  icon={CANAL_ICONS[item.canal] || CANAL_ICONS.Outro}
                                  width={16}
                                  height={16}
                                />
                              </Box>
                              <Box sx={{ flex: 1, minWidth: 0 }}>
                                <Stack
                                  direction="row"
                                  alignItems="baseline"
                                  justifyContent="space-between"
                                  spacing={1}>
                                  <Typography variant="subtitle2" noWrap>
                                    {item.canal}
                                  </Typography>
                                  <Typography
                                    variant="caption"
                                    color="text.secondary"
                                    sx={{ flexShrink: 0 }}>
                                    {item.data_interacao
                                      ? formatDate(String(item.data_interacao).substring(0, 10))
                                      : '-'}
                                  </Typography>
                                </Stack>
                                <Typography
                                  variant="caption"
                                  display="block"
                                  sx={{
                                    color: item.resultado
                                      ? `${RESULT_COLORS[item.resultado] || 'warning'}.main`
                                      : 'text.secondary'
                                  }}>
                                  {item.resultado || '-'}
                                  {' · '}
                                  {item.usuario?.nome || 'Usuário'}
                                </Typography>
                                {item.obs && (
                                  <Typography
                                    variant="body2"
                                    color="text.secondary"
                                    sx={{ mt: 0.25 }}>
                                    {item.obs}
                                  </Typography>
                                )}
                              </Box>
                            </Stack>
                          ))}
                        </Stack>
                      )}
                    </>
                  )}
                </CustomGrid>
              </Scrollbar>
            </Box>
            <Stack
              direction="row"
              spacing={1}
              justifyContent="space-between"
              sx={{ px: 2, py: 1.5, borderTop: 1, borderColor: 'divider' }}>
              <Box>
                {infoState.id_type_user === 1 && infosLead.id_lead && (
                  <Button
                    type="button"
                    variant="contained"
                    color="primary"
                    onClick={getLeadHistory}
                    startIcon={<ManageHistoryIcon />}>
                    Histórico
                  </Button>
                )}
              </Box>
              <Stack direction="row" spacing={1}>
                <Button
                  color="success"
                  variant="contained"
                  type="submit"
                  startIcon={<Iconify icon="eva:save-fill" />}>
                  Atualizar
                </Button>
                <Button
                  type="button"
                  onClick={HandleClose}
                  color="error"
                  variant="contained"
                  startIcon={<Iconify icon="eva:close-circle-fill" />}>
                  Cancelar
                </Button>
              </Stack>
            </Stack>
          </form>
        </Box>
      </Drawer>

      <HistoryLead
        openModal={openHistory}
        setOpenModal={setOpenHistory}
        infosHistoryLead={infosHistoryLead}
      />

      <BootstrapDialog
        onClose={() => setOpenInteracao(false)}
        aria-labelledby="interacao-dialog-title"
        fullWidth
        maxWidth="sm"
        open={openInteracao}>
        <BootstrapDialogTitle id="interacao-dialog-title" onClose={() => setOpenInteracao(false)}>
          Registrar interação
        </BootstrapDialogTitle>
        <DialogContent dividers>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <TextField
                select
                variant="outlined"
                fullWidth
                size="small"
                label="Tipo"
                value={interaction.canal}
                onChange={(e) => setInteraction({ ...interaction, canal: e.target.value })}>
                {INTERACTION_CANALS.map((c) => (
                  <MenuItem key={c} value={c}>
                    {c}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                select
                variant="outlined"
                fullWidth
                size="small"
                label="Resultado"
                value={interaction.resultado}
                onChange={(e) => setInteraction({ ...interaction, resultado: e.target.value })}>
                {INTERACTION_RESULTS.map((r) => (
                  <MenuItem key={r} value={r}>
                    {r}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12}>
              <TextField
                variant="outlined"
                fullWidth
                size="small"
                label="Observação"
                multiline
                minRows={2}
                value={interaction.obs}
                onChange={(e) => setInteraction({ ...interaction, obs: e.target.value })}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            color="success"
            variant="contained"
            type="button"
            onClick={addInteraction}
            startIcon={<Iconify icon="eva:save-fill" />}>
            Registrar
          </Button>
          <Button
            type="button"
            onClick={() => setOpenInteracao(false)}
            color="error"
            variant="contained"
            startIcon={<Iconify icon="eva:close-circle-fill" />}>
            Cancelar
          </Button>
        </DialogActions>
      </BootstrapDialog>

      <BootstrapDialog
        onClose={() => {
          setOpenTag(false);
          setSelectedTagId('');
        }}
        aria-labelledby="tag-dialog-title"
        fullWidth
        maxWidth="sm"
        open={openTag}>
        <BootstrapDialogTitle
          id="tag-dialog-title"
          onClose={() => {
            setOpenTag(false);
            setSelectedTagId('');
          }}>
          Adicionar tag
        </BootstrapDialogTitle>
        <DialogContent dividers>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                select
                variant="outlined"
                fullWidth
                size="small"
                label="Tag"
                value={selectedTagId}
                onChange={(event) => setSelectedTagId(event.target.value)}>
                <MenuItem value="">Selecione</MenuItem>
                {tagsCatalogo.map((t) => (
                  <MenuItem key={t.id_tag} value={t.id_tag}>
                    {t.tag}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            color="success"
            variant="contained"
            type="button"
            onClick={addTagLead}
            startIcon={<Iconify icon="eva:save-fill" />}>
            Adicionar
          </Button>
          <Button
            type="button"
            onClick={() => {
              setOpenTag(false);
              setSelectedTagId('');
            }}
            color="error"
            variant="contained"
            startIcon={<Iconify icon="eva:close-circle-fill" />}>
            Cancelar
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </>
  );
};

addEditLead.propTypes = {
  openModal: PropTypes.bool,
  setOpenModal: PropTypes.func,
  infosItemEdit: PropTypes.object,
  functionGrid: PropTypes.func
};

export default addEditLead;
